$(document).ready(function() {

    $(window).load(function(){
      //Google Map          
	  var latlng = new google.maps.LatLng(35.522659, 138.846748);
      var settings = {
        zoom: 17,
        center: new google.maps.LatLng(35.522659, 138.846748), mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        scrollwheel: false,
        draggable: true,
        mapTypeControlOptions: {style: google.maps.MapTypeControlStyle.DROPDOWN_MENU},
        zoomControlOptions: {position: google.maps.ControlPosition.RIGHT_CENTER},
        streetViewControl: true,
        streetViewControlOptions: {position: google.maps.ControlPosition.RIGHT_CENTER},
        fullscreenControlOptions: {position: google.maps.ControlPosition.LEFT_CENTER},
        navigationControl: false,
        navigationControlOptions: {style: google.maps.NavigationControlStyle.SMALL},
        mapTypeId: google.maps.MapTypeId.ROADMAP};
      var map = new google.maps.Map(document.getElementById("map_canvas"), settings); 
      google.maps.event.addDomListener(window, "resize", function() {
        var center = map.getCenter();
        google.maps.event.trigger(map, "resize");
        map.setCenter(center);
      }); 
      var contentString = 
        '<div id="googlemap_wrap">'+
        '  <h3 id="hl_googlemap">株式会社 槙田商店</h3>'+
        '  <h4 id="hlj_googlemap">MAKITA-SHOTEN CO.,LTD</h4>'+
        '  <div id="txt_googlemap">'+
        '    <p>山梨県南都留郡西桂町小沼1717<br><a href="https://www.google.co.jp/maps/place/（株）槙田商店/@35.5226591,138.8461975,19z/data=!3m1!4b1!4m5!3m4!1s0x60196784d04b1db3:0xee3352fbce0c5b16!8m2!3d35.522658!4d138.846746?hl=ja" target="_blank">GOOGLE MAP</a></p>'+
        '  </div>'+
        '</div>';
      var infowindow = new google.maps.InfoWindow({
        content: contentString
      }); 
      var companyImage = new google.maps.MarkerImage('https://www.makita-1866.jp/cdn/shop/t/14/assets/marker.png',
        new google.maps.Size(55,59), //マーカーの幅と高さ
        new google.maps.Point(0,0),
        new google.maps.Point(27,50) //マーカーの位置
      );
      var companyPos = new google.maps.LatLng(35.522659, 138.846748); 
      var companyMarker = new google.maps.Marker({
        position: companyPos,
        map: map,
        icon: companyImage,               
        zIndex: 3});
      google.maps.event.addListener(companyMarker, 'click', function() {
        infowindow.open(map,companyMarker);
      });

//color change
	  var stylez = [{"stylers":[{ "saturation": -100 },{ lightness: 0 },{ gamma: 1.0 },{hue: "#fff"}]}];
	  var styledMapOptions = {}
	  var styledMapType =  new google.maps.StyledMapType(stylez,styledMapOptions);
	  map.mapTypes.set('株式会社 槙田商店', styledMapType);
	  map.setMapTypeId('株式会社 槙田商店');

    });
  
});